import React from 'react';

const BottomFooter = () => {
  return (
    <footer className='bottom-footer'>
      <div className='container container-lg'>
        <p className='bottom-footer__text center py-20'>
          © {new Date().getFullYear()} <span>Rarenett Technologies</span>. All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default BottomFooter;
